import React, { FC } from 'react';
import Masthead, { MastheadLink, MastheadTitle } from '@amzn/meridian/masthead';
import Text from '@amzn/meridian/text';
import Toggle from '@amzn/meridian/toggle';
import ProgramType from 'src/types/programType';
import { GFC_PATHS, GfcEuPaths, GO_PATHS, INTAKE_FOLDER_PATH, PATHS, TICKETING_PATH } from 'src/constants/routes';
import { useLocation, useNavigate } from 'react-router-dom';
import Button from '@amzn/meridian/button';
import { FEEDBACK_TEXT, REPORT_ISSUE } from '@constants/strings';
import FeatureName from '@constants/featureName';
import useFeatureFlag from 'src/hooks/useFeatureFlag';
import useFeatureFlagControls from 'src/hooks/useFeatureFlagControls';

interface Props {
  programType: ProgramType;
}
const AgileNavBar: FC<Props> = ({ programType }: Props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const nextGenEnabled = useFeatureFlag(FeatureName.NEXT_GEN_V2);
  const { setFeatureStatus } = useFeatureFlagControls();

  // Check if demo mode is enabled via URL parameter
  const searchParams = new URLSearchParams(location.search);
  const isDemoMode = searchParams.get('demo') === '1';

  const handleToggleChange = (checked: boolean) => {
    setFeatureStatus(FeatureName.NEXT_GEN_V2, checked);
  };
  return (
    <Masthead size="large" data-cy="agile_nav_bar">
      <MastheadTitle href={`/${programType.toString()}`}>
        <Text type="h400">{programType}</Text>
      </MastheadTitle>
      {(programType === ProgramType.AmazonFresh || programType === ProgramType.WholeFoods) &&
        PATHS.map((path) => (
          <MastheadLink
            href={path.url}
            onClick={navigate}
            selected={location.pathname.replace(/^\/[^/]+\//, '') === path.url}
            key={`link_${path.url}`}
          >
            {path.name}
          </MastheadLink>
        ))}
      {programType === ProgramType.Go &&
        GO_PATHS.map((path) => (
          <MastheadLink
            href={path.url}
            onClick={navigate}
            selected={location.pathname.replace(/^\/[^/]+\//, '') === path.url}
            key={`link_${path.url}`}
          >
            {path.name}
          </MastheadLink>
        ))}
      {programType === ProgramType.Gfc &&
        GFC_PATHS.map((path) => (
          <MastheadLink
            href={path.url}
            onClick={navigate}
            selected={location.pathname.replace(/^\/[^/]+\//, '') === path.url}
            key={`link_${path.url}`}
          >
            {path.name}
          </MastheadLink>
        ))}
      {programType === ProgramType.GfcEu &&
        GfcEuPaths.map((path) => (
          <MastheadLink
            href={path.url}
            onClick={navigate}
            selected={location.pathname.replace(/^\/[^/]+\//, '') === path.url}
            key={`link_${path.url}`}
          >
            {path.name}
          </MastheadLink>
        ))}
      {isDemoMode && (
        <Toggle checked={nextGenEnabled} onChange={handleToggleChange} size="small" data-cy="next_gen_v2_toggle">
          <Text type="b300">V2</Text>
        </Toggle>
      )}
      <Button href={TICKETING_PATH} type="tertiary" rel="noreferrer" target="_blank" data-cy="report_issue_button">
        {REPORT_ISSUE}
      </Button>
      <Button href={INTAKE_FOLDER_PATH} type="tertiary" rel="noreferrer" target="_blank" data-cy="feedback_button">
        {FEEDBACK_TEXT}
      </Button>
    </Masthead>
  );
};
export default AgileNavBar;
